import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { UtmLeadService } from "../services/utmleads/utmLeads.service";
import { persistUtmReferral, resolveUtmReferral } from "../services/utmleads/utmReferral";

export function useUtmTracking({ createLead = false } = {}) {
  const [searchParams] = useSearchParams();
  const searchParamsKey = searchParams.toString();

  useEffect(() => {
    const referral = persistUtmReferral(
      resolveUtmReferral(new URLSearchParams(searchParamsKey)),
    );

    if (!createLead || !referral?.clickId || !referral?.partnerId) return;

    void UtmLeadService.createUtmLead({
      payload: {
        partnerId: referral.partnerId,
        clickId: referral.clickId,
        typeCustomer: referral.typeCustomer,
      },
    }).then((response) => {
      if (response.error) {
        console.warn(`[UtmLead] No fue posible crear el lead: ${response.message}`);
        return;
      }

      const operationIdUtm = response.message?.data?.operationIdUtm;
      if (operationIdUtm) localStorage.setItem("operationIdUtm", operationIdUtm);
    });
  }, [createLead, searchParamsKey]);
}
